import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {Area} from 'organization/Event/AreasProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {useQuery} from 'react-query'

export function useAreas() {
  const {event} = useEvent()

  const {client} = useOrganization()

  return useQuery({
    queryKey: ['events', event.id, 'areas'],
    queryFn: () => client.get<Area[]>(api(`/events/${event.id}/areas`)),
  })
}
